import { Box, Typography, useTheme, Paper } from "@mui/material";
import { Icons } from "../../data/icons";
import { FeatureItem } from "../../types/CarrerContent";
import useResponsiveSpacingGrid from "../../hooks/useResponsiveSpacingGrid";

interface WhatMakesHungerfordDifferentProps {
  heading: string;
  features: FeatureItem[];
}

const WhatMakesHungerfordDifferent = ({
  heading,
  features,
}: WhatMakesHungerfordDifferentProps) => {
  const theme = useTheme();
  const spacing = useResponsiveSpacingGrid();

  return (
    <Box
      component="section"
      sx={{
        pt: { xs: 0, sm: 4 },
        mt: 4,
        maxWidth: "1050px",
        mx: "auto",
        mb: { xs: 3, sm: 8 },
      }}
    >
      <Typography
        variant="h3"
        align="left"
        fontWeight="bold"
        gutterBottom
        sx={{ mb: { xs: 4, sm: 6, md: 6 } }}
      >
        {heading}
      </Typography>

      {/* Lista de franjas */}
      <Box display="flex" flexDirection="column" gap={spacing}>
        {features.map(({ icon, title, text }, index) => {
          const IconComponent = Icons[icon];

          return (
            <Paper
              key={index}
              elevation={0}
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                gap: 2,
                px: { xs: 3, sm: 4 },
                py: { xs: 3, sm: 4 },
                borderRadius: 2,
                border: `1px solid ${theme.palette.text.disabled}`,
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.secondary.main,
              }}
            >
              {IconComponent && (
                <Box
                  sx={{
                    minWidth: "48px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <IconComponent size={36} color={theme.palette.primary.main} />
                </Box>
              )}
              <Box>
                <Typography
                  variant="h6"
                  fontWeight={600}
                  gutterBottom
                  sx={{ textAlign: { xs: "center", sm: "justify" } }}
                >
                  {title}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ textAlign: { xs: "center", sm: "justify" } }}
                >
                  {text}
                </Typography>
              </Box>
            </Paper>
          );
        })}
      </Box>
    </Box>
  );
};

export default WhatMakesHungerfordDifferent;
